import tippy from "tippy.js";
import jquery from "jquery";
import { initIntersectionObserver } from "@plugins";

const $ = jquery;

$(document).ajaxSuccess(() => initDataTargetTooltips());

window.addEventListener("load", () => initDataTargetTooltips());

function initDataTargetTooltips() {
    const tooltips = document.querySelectorAll("[data-tooltip-target]");

    if (tooltips && tooltips.length) {
        for (const tooltip of tooltips) {
            const tooltipHasContent = tooltip.querySelector("[data-tooltip-content]");
            const tooltipNotInitialized = !tooltip.hasAttribute(["data-tippy-activated"]);

            if (tooltipHasContent && tooltipNotInitialized) {
                initIntersectionObserver(tooltip, initDataTargetTooltip);
            }
        }
    }
}

function initDataTargetTooltip(target) {
    tippy(target, {
        arrow: true,
        placement: "top",
        trigger: "mouseenter click",
        interactive: true,

        allowHTML: true,
        hideOnClick: true,
        theme: "light",

        popperOptions: {
            modifiers: [
                {
                    name: "flip",
                    options: {
                        allowedAutoPlacements: ["top", "bottom"],
                    },
                },
            ],
        },
        onCreate(instance) {
            instance.reference.setAttribute("data-tippy-activated", "true");
            instance.setContent(instance.reference.querySelector("[data-tooltip-content]"));
        },
        appendTo: () => document.body,
    });
}
